module.exports = __webpack_public_path__ + "img/ac.2f889ac7.svg";